<template>

    <div class="container">

        <app-head :title="manufacturer.meta_title || manufacturer.short_name || manufacturer.name">
            <meta name="description" :content="manufacturer.meta_description" v-if="manufacturer.meta_description">
        </app-head>

        <div class="my-4">
            <h1>{{ manufacturer.short_name || manufacturer.name }}</h1>
            <div v-if="manufacturer.image">
                <img :src="manufacturer.image" class="img-fluid" :alt="manufacturer.short_name || manufacturer.name" style="max-width: 200px;" loading="lazy" />
            </div>
            <div class="lead" v-if="manufacturer.description" v-html="manufacturer.description">
            </div>
        </div>

        <results :total="products.meta.total" :from="products.meta.from" :to="products.meta.to" :filters="filters" />

        <product-list :products="products.data" />

        <pagination :links="products.meta.links" />

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    export default {
        props: [
            'manufacturer',
            'products',
            'filters',
        ],
        components: {
            Results,
            Pagination,
            Breadcrumbs,
            ProductList,
        }
    }
</script>